import { render, staticRenderFns } from "./stepTwo.vue?vue&type=template&id=e22178e4&lang=pug&"
import script from "./stepTwo.vue?vue&type=script&setup=true&lang=js&"
export * from "./stepTwo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports